$(document).ready(function(){
  $('.gb-logo-list-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        dots: false,
        infinite: true,
        arrows: false,
        pauseOnHover: false,
        cssEase: 'linear',
		 responsive: [{
    breakpoint: 1023,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: false,
    }
  }]
});

  
$('.gb-media-with-text-image-slider').slick({
        infinite: true,
        speed: 1000,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        arrows: false,
        dots: false,
        prevArrow: $('.prev-graam'),
        nextArrow: $('.next-graam'),
		 responsive: [{
    breakpoint: 1023,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
    }
}]
}); 

  
$('.icons-with-text').slick({
        infinite: true,
        speed: 1000,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: false,
        arrows: false,
        dots: true,
        prevArrow: $('.prev-graam'),
        nextArrow: $('.next-graam'),
		 responsive: [{
    breakpoint: 1023,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
    }
}]
});   



$(document).ready(function(){
  
    setTimeout(function () {
      $(".gb-tab-block-main").css({"opacity":"1"});
  var tabWrapper = $('#tab-block'),
      tabMnu = tabWrapper.find('.tab-mnu  li'),
      tabContent = tabWrapper.find('.tab-cont > .tab-pane');
  
  tabContent.not(':first-child').hide();
  
  tabMnu.each(function(i){
    $(this).attr('data-tab','tab'+i);
  });
  tabContent.each(function(i){
    $(this).attr('data-tab','tab'+i);
  });
  
  tabMnu.click(function(){
    var tabData = $(this).data('tab');
    tabWrapper.find(tabContent).hide();
    tabWrapper.find(tabContent).filter('[data-tab='+tabData+']').show(); 
  });
  
  $('.tab-mnu > li').click(function(){
    var before = $('.tab-mnu li.active');
    before.removeClass('active');
    $(this).addClass('active');
   });
     }, 3500);
});

 $(document).ready(function(){
     $('body').on('click', '.gb-play-pause-button', function(){  
       var get_attr = $(this).attr('attr_play_pause');
     if(get_attr == 'true') {
        $(this).closest(".gb-slidehow").find('video').trigger('pause');
        $(this).attr('attr_play_pause', 'false');
     }else{  
        $(this).closest(".gb-slidehow").find('video').trigger('play');
         $(this).attr('attr_play_pause', 'true');
     }
      
       
    });
   });

   $(document).ready(function(){
     $('body').on('click', '.gb', function(){  
        $(".gb-quick-add-trigger").trigger('click');
     });
  });


   $(document).ready(function(){
     $('body').on('click', '.gb-contacts-app-main-click', function(){  
        $(".gb-contacts-app-main .gb-cart-drawer.site-header__drawers-container .site-header__cart").addClass('is-active');
     });
      $('body').on('click', '.gb-contacts-app-main .site-nav__close-cart button', function(){  
        $(".gb-contacts-app-main .gb-cart-drawer.site-header__drawers-container .site-header__cart").removeClass('is-active');
     });

  
    /*$('body').on('click', '.chat-online', function(){  alert('jj');
         $(".gb-contacts-app-main .gb-cart-drawer.site-header__drawers-container .site-header__cart").removeClass('is-active');
       // var gbg =  $("#ShopifyChat::shadow").shadowRoot;
        //var fdf =  gbg.find('.chat-toggle ::shadow');
              $("#ShopifyChat").shadowRoot.find('.chat-toggle').addClass('is-active');                                       
     });*/
     setTimeout(function () {
        var get_ele = document.getElementById('ShopifyChat');
        var style = document.createElement( 'style' )
        style.innerHTML = ".chat-toggle { max-width: 100% !important;  width: 100% !important;  height: auto !important;     opacity: 0!important; }"
        get_ele.shadowRoot.appendChild( style );

       /*var get_ele2 = document.getElementById('ShopifyChat');
        var style2 = document.createElement( 'style' )
        style2.innerHTML = ".chat-header { background-color: #fff !important; }"
        get_ele2.shadowRoot.appendChild( style2 );

        var get_ele3 = document.getElementById('ShopifyChat');
        var style3 = document.createElement( 'style' )
        style3.innerHTML = ".chat-header button svg { color: #000 !important; }"
        get_ele3.shadowRoot.appendChild( style3 );

        var get_ele4 = document.getElementById('ShopifyChat');
        var style4 = document.createElement( 'style' )
        style4.innerHTML = ".chat-header h2#chat-title { color: #000 !important; }"
        get_ele4.shadowRoot.appendChild( style4 );

        var get_ele5 = document.getElementById('ShopifyChat');
        var style5 = document.createElement( 'style' )
        style5.innerHTML = ".chat-messages__list {  background-color: #000 !important; }"
        get_ele5.shadowRoot.appendChild( style5 );

        var get_ele6 = document.getElementById('ShopifyChat');
        var style6 = document.createElement( 'style' )
        style6.innerHTML = ".date-header {  color: #fff !important; }"
        get_ele6.shadowRoot.appendChild( style6 );

        var get_ele7 = document.getElementById('ShopifyChat');
        var style7 = document.createElement( 'style' )
        style7.innerHTML = ".message-bubble.message-bubble-outgoing {   background-color: #fff !important;  color: #000 !important; }"
        get_ele7.shadowRoot.appendChild( style7 );

        var get_ele8 = document.getElementById('ShopifyChat');
        var style8 = document.createElement( 'style' )
        style8.innerHTML = ".timestamp {  color: #000000 !important; }"
        get_ele8.shadowRoot.appendChild( style8 );

        var get_ele9 = document.getElementById('ShopifyChat');
        var style9 = document.createElement( 'style' )
        style9.innerHTML = ".chat-main-body {  background: #000 !important; }"
        get_ele9.shadowRoot.appendChild( style9 );

        var get_ele10 = document.getElementById('ShopifyChat');
        var style10 = document.createElement( 'style' )
        style10.innerHTML = " form.composer-bar-form {  background-color: #000000 !important; }"
        get_ele10.shadowRoot.appendChild( style10 );

        var get_ele11 = document.getElementById('ShopifyChat');
        var style11 = document.createElement( 'style' )
        style11.innerHTML = " .composer-bar__footer svg {  fill : #fff !important; }"
        get_ele11.shadowRoot.appendChild( style11 );*/

      }, 1500);  

   

    
  /*$('body').on('click', '.chat-online', function(){  alert('jj');
       var gbg =  $("#ShopifyChat").shadowRoot;
       var fdf =  $("#ShopifyChat").find('.chat-toggle').addClass('is-active');                                           
    });   */
    $('body').on('click', '.gb-contact-drawer-advisor', function(){  
            //$(".add-to-cart.servicify-select-a-time-button").trigger('click'); 
            // $(".gb-book-a-time").trigger('click');      
            //$("div#pa-widget").css({"display": "flex"});
       $(".gb-contacts-app-main .gb-cart-drawer.site-header__drawers-container .site-header__cart").addClass('is-active');
     });

  });


   $('body').on('click', '.gift-with-Wrapping-click', function(){  
    
    $(".gb-gift-trigger").trigger('click');     
    /* var valueofvariant = $('.gift-frree-product-input').val();
    var note_get =  $('.gift-with-Wrapping-text-add').val();
   
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async:false,
      data:{
             quantity: 1,
             id: valueofvariant,
             "properties": { "Note": note_get }
            },
      dataType: 'json',
          success: function(line_item) { 
            //   $(".gb-gift-trigger").trigger('click');  
            open();
           }
    });*/
    
  });
  //$(".gift-with-Wrapping-text-add").keyup(function(){
  $('body').on('keyup', '.gift-with-Wrapping-text-add', function(){    
     var get_text = $(this).val();
     $('.note-add-text').val(get_text);
  });
  $('body').on('click', '.add-note', function(){     
      //$(this).closest(".cart__item-row").find('.gift-with-Wrapping-click').toggleClass("hide");
      $(this).closest(".cart__item-row").find('.gift-with-Wrapping-text-image-main').toggleClass("hide");
      if($(this).find('.gift-with-Wrapping-checkbox').is(':checked')){
        $(this).find('.gift-with-Wrapping-checkbox').prop('checked', false);
      }else{  
         $(this).find('.gift-with-Wrapping-checkbox').prop('checked', true);
      }
  });
  $('body').on('click', '.gift-with-Wrapping-checkbox', function(){     
      if($(this).is(':checked')){
        $(this).prop('checked', false);
      }else{  
         $(this).prop('checked', true);
      }
  });
   $('body').on('click', '.gift-wrap-reset', function(){   
       setTimeout(function () {
         $(".add-note").trigger('click');   
       }, 2500);     
  });
   
   $('body').on('click', '.gb-click-contact-Email.to.inquire2', function(){   
    //   window.location.href = '/pages/contact';      
  });
  $('body').on('click', 'label.variant__button-label', function(){   
       //window.location.href = '/pages/contact';
      setTimeout(function () { 
        // $('.gb-click-contact-Email.to.inquire span').html('<a href="/pages/contact">Email to inquire</a>')
      }, 1000); 
      // $('.add-to-cart').hide();
      setTimeout(function () { 
      var btn_text = $('.add-to-cart span').html();
        if(btn_text == 'Email to inquire') {
        //   $('.add-to-cart').show();
          //$('.add-to-cart span').addClass('gb-pad-add');
          $('.add-to-cart span').html('<a href="/pages/contact">Email to inquire</a>');
        } else{
         // $('.add-to-cart').show();
          //$('.add-to-cart span').removeClass('gb-pad-add');
        }   
        }, 2000);   
  });
      
});